import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import SwiperComponent from 'swiper'
import { ServiceModel } from '../../../types/services/serviceModel'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import fetchFactory from '../../../utils/fetchFactory'
import { FormattedMessage, useIntl } from 'react-intl'
import { saveServices } from '../../reducers/services/actions'
import errorCatcher from '../../../utils/errorCatcher'
import Loader from '../../../components/loader/Loader'
import ServiceCard from './ServiceCard'
import 'swiper/swiper.scss'
import { Swiper, SwiperSlide } from 'swiper/react'
import Link from '../../../components/link/Link'
import classNames from 'classnames'
import links from '../../../enums/linksEnum'
import { useHistory } from 'react-router'

const useStyle = makeStyles(
    (theme) =>
        (
            {
                ...styles(theme),
                headerServicesStyle: {
                    marginTop: 30,
                    marginBottom: 25,

                    '& h1': {
                        color: theme.palette.blue.main
                    }
                },
                carrouselStyle:{
                    '& .swiper-slide-prev': {
                        overflow: 'hidden'
                    }
                }
            }
        )
)

const ID_SERVICES = 'services'

const Services = () => {
    const classes = useStyle()
    const history = useHistory()
    const intl = useIntl()
    const services: ServiceModel = useSelector((state: RootState) => state.services)
    const dispatch = useDispatch()
    const [loading, setLoading] = useState<boolean>(false)
    const [swiper, setSwiper] = useState<SwiperComponent>()

    const headerServicesClass = classNames(
        classes.flex,
        classes.flexBetween,
        classes.alignCenter,
        classes.headerServicesStyle
    )

    const carrouselClass = classNames(
        classes.carrouselStyle
    )

    useEffect(
        () => {
            if (services.content.length === 0 || (services.locale && services.locale !== intl.locale)) {
                setLoading(true)

                fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/information/getServices?language=${intl.locale}`)
                    .then(
                        (response: any) => {
                            dispatch(
                                saveServices({ ...response, locale: intl.locale })
                            )
                        }
                    )
                    .catch(
                        (error: any) => {
                            dispatch(
                                errorCatcher(error, ID_SERVICES)
                            )
                        }
                    )
                    .finally(
                        () => {
                            setLoading(false)
                        }
                    )
            }
        }, [dispatch, intl.locale, services.content.length, services.locale]
    )

    const onButtonClicked = (direction: 'previous' | 'next') => {
        if (direction === 'previous') {
            swiper && swiper.slidePrev()
        } else {
            swiper && swiper.slideNext()
        }
    }

    if (loading) {
        return (
            <Loader />
        )
    }

    const seeServices = () => {
        history.push(links.services)
    }

    if (services.content.length > 0) {
        return (
            <>
                <div className={headerServicesClass}>
                    <h1 className={classes.title3}>
                        <FormattedMessage
                            id="services.title"
                            defaultMessage="Services"
                            description="Services title"
                        />
                    </h1>

                    <Link
                        textStyle="text8"
                        color="colorAccessibility"
                        onClick={seeServices}
                    >
                        <FormattedMessage
                            id="services.link"
                            defaultMessage="Tous les services"
                            description="Services link"
                        />
                    </Link>
                </div>

                <div className={carrouselClass}>
                    {
                        services.content.length > 1 &&
						<Swiper
							onSwiper={setSwiper}
							loop
                            spaceBetween={1}
						>
                            {
                                services.content.map(
                                    (service) => (
                                        <SwiperSlide key={service.id}>
                                            <ServiceCard
                                                service={service}
                                                changeSlide={onButtonClicked}
                                            />
                                        </SwiperSlide>
                                    )
                                )
                            }
						</Swiper>
                    }
                    {
                        services.content.length === 1 &&
						<ServiceCard
							service={services.content[0]}
							changeSlide={onButtonClicked}
						/>
                    }
                </div>
            </>
        )
    } else {
        return (
            <>
            </>
        )
    }
}

export default Services
